import baseUrl from '../../../utils/api';
import axios from 'axios';
import noCover from '@/assets/images/no-cover.png';
import { token } from '@/utils';
import TypeSelect from '../../components/typeSelect2';
import VueCookie from 'vue-cookie';
import Vue from 'vue';
import { getCombinePack, getCombinePackStatus } from '@/api/api';
import packageStatus from '@/components/PackageStatus/index';

export default {
  name: 'classDetail',
  components: {
    TypeSelect,
    packageStatus,
  },
  data() {
    return {
      noCover,
      loading: false,
      id: this.$route.query.id,
      commodities_id: this.$route.query.commodities_id,
      from_goods: /goods/.test(this.$route.path),
      list: {},

      introduce_status: {
        show: false,
        short: '',
      },

      videoData: {
        show: false,
        title: '',
        src: '',
      },

      iframeData: {
        show: false,
        title: '',
        src: '',
        playload: '',
      },

      iframe2Data: {
        show: false,
        title: '',
        src: '',
      },

      classData: {
        state: '加载中...',
        check: {},
        step: 20,
        list: [],
        show: true,
        model: '',
      },

      isLive: false,
      detailP: {
        height: 0,
        can: false,
        show: false,
      },

      token: token.get(),
      isTest: /test/.test(baseUrl.split('/')[2]),
      someData: {},

      offline_left: this.$route.query.offline_left,
      online_left: this.$route.query.online_left,

      isNoNum: false,

      typeSelectDataMe: [
        {
          id: 0,
          name: '所有分类',
          delete: true,
        },
      ],
      typeSelectList: [],

      cacheId: '',
      cacheSelect: {},
      cacheIds: [],
      typeSelectHide: false,
      isPackageStatus: false, // 课包打包状态
      packageItem: null, // 包内容
      packageRate: 0, // 课件包打包进度
      runPackageFn: null, // 轮询打包状态
      isFromGoods: false, // 是否是从课程商品跳转过来
      cover: '',
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name === 'goods') {
        vm.isFromGoods = true;
      } else {
        vm.isFromGoods = false;
      }
    });
  },
  created() {
    this.loading = true;

    this.iframeData.src = `https://oa-statics.caihonggou.com/courseware${this.isTest ? '_test' : ''}/cocosKeJian/index.html?role=preview&server=${baseUrl.split('.')[1]}${this.isTest ? '' : '&env=aikaola'}&token=${this.token}`;

    this.isLive = localStorage.getItem('isLive') === 'true';

    !this.id && (this.id = sessionStorage.getItem('class_detail_id'));
    !this.commodities_id && (this.commodities_id = sessionStorage.getItem('class_detail_commodities_id'));

    let getInfo;

    if (this.id) {
      this.$http.get(`${baseUrl}/api/course/commodities/orders/${this.id}`).then((res) => {
        this.cover = res.data.commodities.cover;
      });

      getInfo = this.$http.get(`${baseUrl}/api/course/commodities/${this.commodities_id}`).then((res) => {
        this.list = res.data;

        this.list.introduction.length > 300 ? (
          this.introduce_status.short = `${this.list.introduction.substring(0, 300)}...`
        ) : (
          this.introduce_status.show = true
        );

        setTimeout(() => {
          if (this.$refs.detail_p.offsetHeight > 40) {
            this.detailP.can = true;
          }
        }, 100);

        this.$http.get(`${baseUrl}/api/course/commodities/${this.commodities_id}`).then((res) => {
          this.typeSelectList = res.data.category_tree || [];
          !this.typeSelectList.length && (this.typeSelectHide = true);
        });

        this.typeSelectList = res.data.category_tree || [];
        !this.typeSelectList.length && (this.typeSelectHide = true);
      });
    } else {
      getInfo = this.$http.get(`${baseUrl}/api/course/commodities/${this.commodities_id}`).then((res) => {
        this.list = res.data;

        this.cover = res.data.cover;

        this.typeSelectList = res.data.category_tree || [];
        !this.typeSelectList.length && (this.typeSelectHide = true);

        this.list.introduction.length > 300 ? (
          this.introduce_status.short = `${this.list.introduction.substring(0, 300)}...`
        ) : (
          this.introduce_status.show = true
        );

        setTimeout(() => {
          if (this.$refs.detail_p.offsetHeight > 40) {
            this.detailP.can = true;
          }
        }, 100);
      });
    }

    const getVideo = this.classPage(1, (list, total) => {
      // let _ind = 0;
      // const radio = [];
      // const step = this.classData.step;
      //
      // if (!total) {
      //   this.classData.state = '暂无';
      //   return;
      // }
      //
      // while (total > 0) {
      //   const slice_start = step * _ind,
      //     slice_end = step * _ind + (total < step ? total : step);
      //
      //   total -= step;
      //
      //   radio.push({
      //     label: _ind,
      //     text: `${1 + slice_start}-${slice_end}`,
      //   });
      //
      //   _ind ++;
      // }
      //
      // radio[0].list = list;
      //
      // this.classData.list = radio;
      // this.classData.model = radio[0].label;

      this.classData.list = list;
    });

    axios.all([getInfo, getVideo]).finally(() => this.loading = false);
  },
  mounted() {
    this.$store.state.iframeFn = (type) => {
      type === 'getConfig' && this.$nextTick(() => {
        iframe.contentWindow.postMessage(
          {
            type: 'getConfig',
            playload: this.iframeData.playload,
          },
          '*',
        );
      });
    };
  },
  destroyed() {
    this.$store.state.iframeFn = undefined;
  },
  methods: {
    // 课时 - 选中
    // classChange (page) {
    //   if (!this.classData.list[page].list) {
    //     this.loading = true;
    //
    //     const _http = this.classPage(1 + page, list => this.classData.list[page].list = list);
    //
    //     _http.finally(() => this.loading = false);
    //   }
    // },

    // 课时 - 请求
    classPage(page, callback) {
      // return this.$http.get(`${baseUrl}/api/course/commodities/${this.id ? `orders/courses?equal[order_id]=${this.id}` : `courses?equal[commodities_id]=${this.commodities_id}`}&order[sort]=asc&per_page=${this.classData.step}&page=${page}`).then(res => {
      // return this.$http.get(`${baseUrl}/api/course/commodities/courses?equal[commodities_id]=${this.commodities_id}&order[sort]=asc&per_page=${this.classData.step}&page=${page}`).then(res => {
      //   const list = [];
      //
      //   res.items.forEach(val => {
      //     if (val.commoditable) {
      //       val.commoditable.liveroom_course_type = val.liveroom_course_type;
      //       val.commoditable.liveroom_new_course_type = val.liveroom_new_course_type;
      //       list.push(val.commoditable);
      //     }
      //   });
      //
      //   callback(list, res.meta.total);
      // });
      return this.$http.get(`${baseUrl}/api/course/commodities/courses?equal[commodities_id]=${this.commodities_id}&order[sort]=asc&per_page=999999`).then((res) => {
        const list = [];

        res.items.forEach((val) => {
          if (val.commoditable) {
            val.commoditable.liveroom_course_type = val.liveroom_course_type;
            val.commoditable.liveroom_new_course_type = val.liveroom_new_course_type;
            val.commoditable.category_ids = val.category_ids;
            list.push(val.commoditable);
          }
        });

        callback(list, res.meta.total);
      });
    },

    // 视频 - 显示
    showVideo(name, src) {
      this.videoData.title = name;
      this.videoData.src = src;
      this.videoData.show = true;
    },

    // 课件视频 - 显示
    showIframe(itm) {
      if (itm.liveroom_course_type == 3) {
        this.iframe2Data.title = itm.name;

        this.iframe2Data.src =
            `https://editor.courseware.${baseUrl.split('.')[1]}.com/preview`
            + '?platform=vue'
            + '&scene=preview'
            + '&fullScreen=true'
            + `&id=${itm.id}`
            + `&version=${itm.attr_id_used}`
            + `&school_id=${localStorage.getItem('school_id') || this.$store.state.choicesSchool.id}`
            // + (this.$store.state.from === 'schoolCenter' ? '' : `&client_id=${this.$store.state.appId}&token=${this.token}`)
        ;

        // this.$store.state.from === 'schoolCenter' && this.iframe2Data.contentWindow.postMessage({
        //   type: 'setEditorConfig',
        //   value: {
        //     token: this.token,
        //     client_id: this.$store.state.appId
        //   }
        // });

        this.iframe2Data.show = true;
      } else if (itm.liveroom_course_type == 2 && itm.enable_recording_id) {
        this.iframeData.title = itm.name;

        this.iframeData.playload = {
          authorization: `Bearer ${this.token}`,
          recordList: itm.enable_recording_id,
        };

        this.iframeData.show = true;
      } else {
        this.$message({
          message: '该课件暂不支持网页上课，请到官网下载pc客户端进行上课；',
          type: 'warning',
        });
      }
    },

    // 课件 - 选中
    checkItem(item) {
      if (JSON.stringify(this.classData.check) !== '{}') {
        this.classData.check = {};
        return;
      }
      this.classData.check = item;
      this.isLive && typeof window.SelectClass !== 'undefined' && window.SelectClass(this.getSomeData());
    },
    // 获取课件包打包进度
    async getPackageProgress(item) {
      console.log('getPackageProgress==>', item);
      const func = async (callback) => {
        const res = await getCombinePackStatus(({
          resultId: item.id,
          clientsId: this.$store.state.choicesSchool.id,
        }));
        if (res && res.status_code === 200) {
          callback({
            ...res.data,
          });
        } else {
          callback(false);
        }
      };
      const callbackFunc = async (res) => {
        if (!res) {
          // 请求失败
        } else {
          const { status, progress, message } = res;
          switch (status) {
            case 'failure':
              // 获取失败
              this.$message.error(message);
              break;
            case 'success': {
              // 去下载
              const result = await getCombinePack({
                resultId: item.id,
                clientsId: this.$store.state.choicesSchool.id,
              });
              this.isPackageStatus = false;
              this.packageItem = null;
              window.open(result.data);
              break;
            }
            case 'run': {
              // 正在打包-有打包进度
              this.packageRate = progress;
              this.runPackageFn = setTimeout(() => {
                func(callbackFunc);
                clearTimeout(this.runPackageFn);
              }, 1000);
              break;
            }
          }
        }
      };
      func(callbackFunc);
    },
    successPackageStatus() {
      clearTimeout(this.runPackageFn);
    },
    // 下载课件
    async downLoad() {
      if (JSON.stringify(this.classData.check) === '{}') {
        this.$message({
          message: '请选择课程',
          type: 'warning',
        });
      } else {
        this.packageRate = 0;
        const res = await getCombinePack({
          resultId: this.classData.check.id,
          clientsId: this.$store.state.choicesSchool.id,
        });

        if (res && res.status_code === 200) {
          // 1.课包已经是最新的，直接下载
          window.open(res.data);
        } else if (res && res.status_code === 407) {
          // 1.课包打包弹窗
          this.isPackageStatus = true;
          this.packageItem = this.classData.check;
          this.getPackageProgress(this.classData.check);
        } else {
          this.$message.warning(res && res.message);
        }
      }
    },

    // 课件 - 主要数据
    getSomeData() {
      const {
        id,
        name,
        title,
        liveroom_course_type,
        liveroom_new_course_type,

        attr_id_used,
        enable_recording_id,
      } = this.classData.check;

      let hide_course_type = '';

      if (this.offline_left == 0) {
        hide_course_type = 'offline_left'; // 隐藏 线下课
      } else if (this.online_left == 0) {
        hide_course_type = 'online_left'; // 隐藏 线上课
      }

      const commodities_orders_code = this.$route.query.code;

      this.someData = JSON.stringify({
        id,
        name,
        title,
        liveroom_course_type, // 值为2或3跳转, 否则不要跳转, 提示 "暂不支持网页上课"
        liveroom_new_course_type,
        commodities_orders_code,
        hide_course_type, // 'offline_left': 隐藏线下课; 或 'online_left': 隐藏线上课
        attr_id_used, // 预览 - 互动课件
        enable_recording_id, // 预览 - AI双师
      });
      console.log(this.someData)
      return this.someData;
    },

    // 视频 - 选中
    loadVideo(name, course_id) {
      this.loading = true;

      this.$http.post(`${baseUrl}/api/imkid/local_video/download`, {
        course_id,
      }).then((res) => {
        this.showVideo(name, res.video_info.resolution.has_shd_mp4);
      }).catch((res) => {
        this.$message.error(res.message);
      }).finally(() => {
        this.loading = false;
      });
    },

    // 视频 - 播放
    videoOpen() {
      this.$refs.ref_video.play();
    },

    // 视频 - 关闭
    videoClose() {
      this.$refs.ref_video.pause();
    },

    // 课程 - 预览
    classSee() {
      const _check = this.classData.check;

      _check.id ? this.showIframe(_check) : this.$message({
        message: '请先勾选课时',
        type: 'warning',
      });
    },

    // 课程 - 购买
    classBuy() {
      this.id && sessionStorage.setItem('class_detail_id', this.id);
      this.commodities_id && sessionStorage.setItem('class_detail_commodities_id', this.commodities_id);
      sessionStorage.setItem('classDetailList', JSON.stringify(this.list));

      this.$router.push({
        path: '/goods/classDetail/classBuy',
        query: {
          id: this.commodities_id,
        },
      });
    },

    // 课程 - 去购买
    getBuy() {
      this.isNoNum = false;

      if (typeof window.JumpToGoods !== 'undefined' && this.$route.query.from !== 'order') {
        window.JumpToGoods();
      } else {
        this.$router.replace('/goods');
      }
    },

    // 课程 - 上课
    classGo() {
      if (this.classData.check.id) {
        if (this.classData.check.liveroom_course_type !== 3 && typeof window.JumpToGoods === 'undefined') {
          this.$message({
            message: '该课件类型，暂不支持发起上课',
            type: 'warning',
          });
        } else {
          this.loading = true;

          this.$http.get(`${baseUrl}/api/course/commodities/orders/${this.id}`).then((res) => {
            const data = res.data;
            this.offline_left = data.offline_left;
            this.online_left = data.online_left;

            this.getSomeData();

            if (data.offline_left || data.online_left) {
              if (typeof window.ToClass !== 'undefined') {
                window.ToClass(this.someData);
              } else {
                localStorage.setItem('my_class_data', this.someData);
                this.$router.push('/myClass/myCreate');
              }
            } else {
              this.isNoNum = true;
            }
          }).finally(() => {
            this.loading = false;
          });
        }
      } else {
        this.$message({
          message: '请先勾选课时',
          type: 'warning',
        });
      }
    },

    onTypeSelectLoop(children) {
      for (let i = 0; i < children.length; i++) {
        const ci = children[i];

        if (this.cacheId === ci.id) {
          this.cacheSelect = ci;
          break;
        }

        if (ci.recursive_children && ci.recursive_children.length) {
          this.onTypeSelectLoop(ci.recursive_children);
        }
      }
    },

    onTypeIdsLoop(children) {
      for (let i = 0; i < children.length; i++) {
        const ci = children[i];

        this.cacheIds.push(ci.id);

        if (ci.recursive_children && ci.recursive_children.length) {
          this.onTypeIdsLoop(ci.recursive_children);
        }
      }
    },

    onTypeSelect(val, list) {
      if (val.id) {
        this.cacheId = val.id;
        this.cacheIds = [];

        this.onTypeSelectLoop(list);
        this.cacheIds.push(this.cacheSelect.id);
        this.cacheSelect.recursive_children && this.cacheSelect.recursive_children.length && this.onTypeIdsLoop(this.cacheSelect.recursive_children);

        this.classData.list.forEach((item) => {
          if (item.category_ids && this.cacheIds.some(val => item.category_ids.includes(val))) {
            item.hide = false;
          } else {
            item.hide = true;
          }
        });

        this.$set(this.classData, 'list', this.classData.list);
      } else {
        this.classData.list.forEach((item) => {
          item.hide = false;
        });
      }

      this.updateFormData();
    },

    updateFormData() {
      this.classData.show = false;

      this.$nextTick(() => {
        this.classData.show = true;
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/Goods/ClassDetail/index.js